/**
 * Caret Right Icon - Right-pointing arrow for module triggers
 *
 * Design: 16x16 caret pointing right
 * Usage: Module trigger components, navigation indicators
 * Color: Inherits from parent (uses currentColor)
 */

export const CaretRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.15416 0.103016C4.00416 0.246016 3.99816 0.483016 4.14016 0.633016L11.1082 7.98002L4.10216 15.367C3.96016 15.517 3.96716 15.754 4.11716 15.897C4.26716 16.04 4.50516 16.033 4.64716 15.883L11.8592 8.27802C11.8652 8.27202 11.8622 8.26402 11.8672 8.25702C11.8722 8.25402 11.8792 8.25602 11.8832 8.25102C12.0332 8.10902 12.0402 7.87202 11.8972 7.72202L4.68416 0.117016C4.54216 -0.0329839 4.30416 -0.0399839 4.15416 0.103016Z"
      fill="currentColor"
    />
  </svg>
);
